<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useFaqs from "../../use/useFaqs"

const props = defineProps({
  faqProps: {
    required: true,
    type: Object,
  },
})

const faqData = ref({
  id: props.faqProps.id,
  question: props.faqProps.question,
  answer: props.faqProps.answer,
  status: props.faqProps.status,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useFaqs(
  props,
  emit,
  faqData
)

onUpdated(() => {
  faqData.value = {
    id: props.faqProps.id,
    question: props.faqProps.question,
    answer: props.faqProps.answer,
    status: props.faqProps.status,
  }
})
</script>

<template>
  <!-- edit faq modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" ویرایش پرسش و پاسخ"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
        >
          <div class="mb-3">
            <label for="questionText" class="form-label"> سوال کاربر</label>
            <textarea
              class="form-control"
              id="questionText"
              v-model="faqData.question"
              rows="3"
            ></textarea>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.question">
                <span>{{ errors.question[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="answerText" class="form-label">پاسخ</label>
            <textarea
              class="form-control"
              id="answerText"
              v-model="faqData.answer"
              rows="3"
            ></textarea>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.answer">
                <span>{{ errors.answer[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="status" class="form-label">وضعیت</label>
            <select
              class="form-control"
              data-trigger
              id="statusfield"
              v-model="faqData.status"
            >
              <option value="">وضعیت</option>
              <option value="0">تائید نشده</option>
              <option value="1">تائید شده</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.status">
                <span>{{ errors.status[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">
              ویرایش پرسش و پاسخ
            </b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
